import { IMaskInput } from 'react-imask';
import { Box, Grid, InputBase, Select, Text, TextInput } from '@mantine/core';
import { DateInput } from '@mantine/dates';
import moment from 'moment';

import InputLabel from 'components/InputLabel';
import SectionTitle from 'components/SectionTitle';
import { MARITAL_STATUSES } from 'constants/App';
import { IPageData } from '.';

const PersonalInformation = ({ form, isMobile, t }: IPageData) => {

  const dateParser = (value: string) => {
    const parts = value.split('.');
    if (parts.length === 3) {
      const day = parseInt(parts[0], 10);
      const month = parseInt(parts[1], 10) - 1;
      const year = parseInt(parts[2], 10);
      return new Date(year, month, day);
    }
    return new Date(value);
  };

  return (
    <Box mt={48}>
      <SectionTitle title={t('section.information.personal')} />
      <Grid columns={isMobile ? 1 : 12}>
        <Grid.Col span={isMobile ? 1 : 12}>
          <TextInput
            label={<InputLabel label={t('input.fullName.label')} />}
            key={form.key('fullName')}
            {...form.getInputProps('fullName')}
          />
          <Text size={'xs'} mt={8}>{t('input.fullName.description')}</Text>
        </Grid.Col>
        <Grid.Col span={isMobile ? 1 : 6}>
          <InputBase
            label={<InputLabel label={t('input.phone.label')} />}
            component={IMaskInput}
            mask={t('input.phone.mask')}
            placeholder={t('input.phone.placeholder')}
            type={'tel'}
            onAccept={(value: string) => {
              if (value.startsWith('+41 0')) {
                form.setFieldValue('phone', '+41 ');
              }
            }}
            key={form.key('phone')}
            {...form.getInputProps('phone')}
          />
        </Grid.Col>
        <Grid.Col span={isMobile ? 1 : 6}>
          <TextInput
            label={<InputLabel label={t('input.email.label')} />}
            placeholder={t('input.email.placeholder')}
            type={'email'}
            key={form.key('email')}
            {...form.getInputProps('email')}
          />
        </Grid.Col>
        <Grid.Col span={isMobile ? 1 : 6}>
          <DateInput
            label={<InputLabel label={t('input.dateOfBirth.label')} />}
            placeholder={t('input.dateOfBirth.placeholder')}
            dateParser={dateParser}
            valueFormat={'DD.MM.YYYY'}
            key={form.key('dateOfBirth')}
            {...form.getInputProps('dateOfBirth')}
            minDate={moment().subtract(65, 'years').toDate()}
            maxDate={moment().subtract(18, 'years').toDate()}
            defaultDate={moment().subtract(18, 'years').toDate()}
          />
        </Grid.Col>
        <Grid.Col span={isMobile ? 1 : 6}>
          <Select
            label={<InputLabel label={t('input.maritalStatus.label')} />}
            placeholder={t('input.maritalStatus.placeholder')}
            data={MARITAL_STATUSES!.map((item) => ({
              value: item,
              label: t(`maritalStatus.${item}`),
            }))}
            key={form.key('maritalStatus')}
            {...form.getInputProps('maritalStatus')}
          />
        </Grid.Col>
      </Grid>
    </Box>
  )
}

export default PersonalInformation;